function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable import/prefer-default-export */
import { EMPTY_ARRAY } from '@deephaven/utils';
import { useState, useCallback, useEffect } from 'react';

/**
 * Configuration options for `usePromiseFactory` hook.
 */

/**
 * Return type of `usePromiseFactory` hook.
 */

/**
 * Manages the result of a promise factory function in a synchronous way.
 * @param promiseFactory The factory function which creates the promise to be awaited.
 * @param args arguments to pass to the factory function.
 * @returns object containing resolved data or error information.
 */
export default function usePromiseFactory(promiseFactory) {
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_ARRAY;
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref$autoLoad = _ref.autoLoad,
    autoLoad = _ref$autoLoad === void 0 ? true : _ref$autoLoad;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    data = _useState2[0],
    setData = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var _useState5 = useState(autoLoad),
    _useState6 = _slicedToArray(_useState5, 2),
    isLoading = _useState6[0],
    setIsLoading = _useState6[1];
  var loadPromise = useCallback(/*#__PURE__*/_asyncToGenerator(function* () {
    setIsLoading(true);
    try {
      var resolved = yield promiseFactory(...args);
      setData(resolved);
      setError(null);
    } catch (err) {
      setData(null);
      setError(err);
    } finally {
      setIsLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }), [promiseFactory, ...args]);
  useEffect(() => {
    if (autoLoad) {
      loadPromise();
    }
  }, [autoLoad, loadPromise]);
  return {
    data,
    error,
    isError: error != null,
    isLoading,
    reload: loadPromise
  };
}
//# sourceMappingURL=usePromiseFactory.js.map